import React, { useEffect, useState } from "react";
import {
  OptionContainer,
  OptionContent,
  OptionLabel,
  SettingsOptionContainer,
} from "../../../styles";
import { CreatableSelect, Select } from "@caelor/ui";
import { useTranslation } from "react-i18next";
import { SpaceStatus, SpaceType } from "../defaults";
import { useSpacesStore } from "../../../../../../../stores/use-space-store";

const createOption = (label) => ({
  label,
  value: label,
});

const SpaceTypeOptions = [
  { label: "Global", value: SpaceType.GLOBAL },
  { label: "Personal", value: SpaceType.PERSONAL },
];

const SpaceStatusOptions = [
  { label: "Active", value: SpaceStatus.ACTIVE },
  { label: "Archived", value: SpaceStatus.ARCHIVED },
];

function Dynamic() {
  const { t } = useTranslation();

  const { data, selectedTab, updateConfigTab } = useSpacesStore((state) => ({
    data: state.data,
    selectedTab: state.getSelectedTab(),
    updateConfigTab: state.updateConfigTab,
  }));

  const [categories, setCategories] = useState([]);
  const [inputValue, setInputValue] = useState(undefined);

  useEffect(() => {
    if (data.config.tabs[selectedTab].categories) {
      setCategories(
        data.config.tabs[selectedTab].categories.map((l) => createOption(l))
      );
    }
  }, [data.config.tabs, selectedTab]);

  const handleKeyDown = (event) => {
    if (!inputValue) return;
    switch (event.key) {
      case "Enter":
      case "Tab":
        setInputValue("");
        setCategories([...categories, createOption(inputValue)]);
        updateConfigTab({
          value: {
            categories: [
              ...data.config.tabs[selectedTab].categories,
              createOption(inputValue),
            ].map((l) => l.label),
          },
        });
        event.preventDefault();
        break;
      default:
        return;
    }
  };

  return (
    <>
      <SettingsOptionContainer>
        <OptionContainer direction="column">
          <OptionLabel>{t("status")}</OptionLabel>
          <OptionContent full>
            <Select
              options={SpaceStatusOptions}
              value={SpaceStatusOptions.find(
                ({ value }) =>
                  value === data.config.tabs[selectedTab].spaceStatus
              )}
              onChange={(value) => {
                updateConfigTab({ value: { spaceStatus: value.value } });
              }}
            />
          </OptionContent>
        </OptionContainer>{" "}
        <OptionContainer direction="column">
          <OptionLabel>{t("type")}</OptionLabel>
          <OptionContent full>
            <Select
              options={SpaceTypeOptions}
              value={SpaceTypeOptions.find(
                ({ value }) => value === data.config.tabs[selectedTab].spaceType
              )}
              onChange={(value) => {
                updateConfigTab({ value: { spaceType: value.value } });
              }}
            />
          </OptionContent>
        </OptionContainer>
        <OptionContainer direction="column">
          <OptionLabel>{t("categories")}</OptionLabel>
          <OptionContent full>
            <CreatableSelect
              inputValue={inputValue}
              isClearable
              isMulti
              onChange={(newCategories) => {
                setCategories(newCategories);
                updateConfigTab({
                  value: {
                    categories: newCategories.map((l) => l.label),
                  },
                });
              }}
              placeholder="Select categories"
              menuIsOpen={false}
              onInputChange={(newValue) => setInputValue(newValue)}
              onKeyDown={handleKeyDown}
              value={categories}
            />
          </OptionContent>
        </OptionContainer>
      </SettingsOptionContainer>
    </>
  );
}

export default Dynamic;
